import { primitives } from './primitives.js';

const declaratives = {
    borderRadii: primitives.borderRadii,
    colors: {
        background: {
            accent1: primitives.colors.cream400,
            accent2: primitives.colors.glacier400,
            accent3: primitives.colors.aurora400,
            accent4: primitives.colors.moss400,
            accent5: primitives.colors.rose400,
            accent6: primitives.colors.coral400,
            accent7: primitives.colors.cyan400,
            accent8: primitives.colors.arcadiaGreen400,
            controls: primitives.colors.neutral300,
            error: primitives.colors.red100,
            errorBright: primitives.colors.red400,
            errorDark: primitives.colors.red500,
            primary: primitives.colors.white,
            primaryInverse: primitives.colors.lushGreen400,
            secondary: primitives.colors.neutral100,
            success: primitives.colors.green100,
            successBright: primitives.colors.green400,
            successDark: primitives.colors.green500,
            tertiary: primitives.colors.neutral200,
            warning: primitives.colors.yellow100,
            warningBright: primitives.colors.yellow400,
            warningDark: primitives.colors.yellow500,
        },
        content: {
            accent1: primitives.colors.cream400,
            accent2: primitives.colors.glacier400,
            accent3: primitives.colors.aurora400,
            accent4: primitives.colors.moss400,
            accent5: primitives.colors.rose400,
            // TODO this color needs to be replaced to avoid contrast violation
            accent6: primitives.colors.coral400,
            accent7: primitives.colors.cyan400,
            accent8: primitives.colors.arcadiaGreen400,
            accent9: primitives.colors.lushGreen400,
            error: primitives.colors.red500,
            errorBright: primitives.colors.red400,
            primary: primitives.colors.neutral600,
            primaryInverse: primitives.colors.white,
            secondary: primitives.colors.neutral400,
            success: primitives.colors.green500,
            successBright: primitives.colors.green400,
            warning: primitives.colors.yellow500,
            warningBright: primitives.colors.yellow400,
        },
        maps: {
            backgroundToContent: {
                accent1: 'primary',
                accent2: 'primary',
                accent3: 'primary',
                accent4: 'primary',
                accent5: 'primary',
                accent6: 'primary',
                accent7: 'primary',
                accent8: 'primary',
                controls: 'primary',
                error: 'error',
                errorBright: 'primaryInverse',
                errorDark: 'primaryInverse',
                primary: 'primary',
                primaryInverse: 'primaryInverse',
                secondary: 'primary',
                success: 'success',
                successBright: 'primaryInverse',
                successDark: 'primaryInverse',
                tertiary: 'primary',
                warning: 'warning',
                warningBright: 'primaryInverse',
                warningDark: 'primaryInverse',
            },
            contentToBackground: {
                accent1: 'primaryInverse',
                accent2: 'primaryInverse',
                accent3: 'primaryInverse',
                accent4: 'primaryInverse',
                accent5: 'primaryInverse',
                accent6: 'accent1',
                accent7: 'primaryInverse',
                accent8: 'primaryInverse',
                accent9: 'primary',
                error: 'primary',
                errorBright: 'primary',
                primary: 'primary',
                primaryInverse: 'primaryInverse',
                secondary: 'primary',
                success: 'primary',
                successBright: 'primary',
                warning: 'primary',
                warningBright: 'primary',
            },
        },
    },
    fontFamilies: primitives.fontFamilies,
    fontSizes: primitives.fontSizes,
    iconSizes: primitives.iconSizes,
    lineHeights: primitives.lineHeights,
    logos: primitives.logos,
    media: {
        forPhoneOnly: '@media (max-width: 599px)',
        forTabletPortraitUp: '@media (min-width: 600px)',
        forTabletLandscapeUp: '@media (min-width: 900px)',
        forDesktopUp: '@media (min-width: 1200px)',
        forLargerScreensUp: '@media (min-width: 1800px)',
        /* eslint-enable sort-keys */
    },
    opacities: primitives.opacities,
    transitionDurations: primitives.transitionDurations,
};

export { declaratives };
